import { apiInstance } from 'api/utils';

export default {
  getFirmRiskDescriptions: () => {
    return apiInstance.request({
      method: 'GET',
      url: `/risk-description`
    });
  },
  saveFirmRiskDescriptions: (data: any) => {
    return apiInstance.request({
      method: 'POST',
      url: `/risk-description`,
      data: data
    });
  },
  deleteFirmRiskDescriptions: () => {
    return apiInstance.request({
      method: 'DELETE',
      url: `/risk-description`
    });
  }
};
